import Fuse from 'fuse.js';
import { createApp } from "vue";
import { ModalHelper } from "../B2bTools";
import Store from "../Store";
import b2bDropdownEllipses from "./composant/b2bDropdownEllipses";
import { may, toDate, toPrix, traduit } from "./composant/b2bLangue";
import html from "./orderList.html";

//import orderMassImport from "./orderMassImport.html"

// Chart.js
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    Title,
    Tooltip,
} from 'chart.js';
import { Doughnut } from 'vue-chartjs';
import orderChart from "./orderChart.html";
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

const fuseOptions = {
    threshold: 0.1,
    keys: [
        'order',
        'season',
        'department',
        'ordertype',
        'customer',
        'code',
        'po',
        'dateCre',
        'nbproducts',
        'total',
        'devise',
        'badge'
    ]
}

function getBadge(u) {
    if (u.status == "10") return { v: "in progress", color: 'bg-primary', k: "inprogress" };
    if (u.status == "11") return { v: "Validated", color: 'bg-success', k: "validated" };
    if (u.status == "9") return u.majerp ? { v: "Exported", color: 'bg-secondary', k: "exportded" } : { v: "Confirmed", color: 'bg-warning', k: "confirmed" };
    return { v: "unknown", color: 'bg-warning', k: "???" };
}

function PrepareData(rows) {
    return rows.map(u => ({
        _id: u._id,
        order: `#${u.numeroErp}`,
        season: u.season,
        actions: u.actions,
        customer: u.clientV,
        code: u.clientK,
        ordertype: u.ordertype,
        department: u.orderdepartment,
        po: u.po,
        qui: u.qui,
        massimport: u.massimport,
        dateCre: u.dateCre,
        nbproducts: u.totaux.qt,
        total: u.totaux.ht,
        devise: u.devise,
        status: u.status,
        badge: getBadge(u),
        checked: false,
        inSearch: true,
        majerp: u.majerp,
    }));
}
function PrepareCreators(rows) {
    const cre = new Set();
    for (const r of rows) {
        cre.add(r.qui);
    }
    //console.log(cre);
    return cre;
}

const tabs = [
    { v: "In progress", k: "inprogress", status: 10 },
    { v: "Validated", k: "validated", status: 11 },
    { v: "Confirmed", k: "confirmed", status: 9 },
    { v: "Exported to M3", k: "exportded", status: 9, majerp: 9 },
    { v: "All", k: "all" }
]


const js = ({
    url: function (echangeur) {
        echangeur.addAction('b2b.toc.list', { env: echangeur.hash.u }, '', 'toc');
        echangeur.addAction('b2b.env.getDefault', { env: echangeur.hash.u }, '', 'default');
        echangeur.addAction('b2b.orders.list', { env: echangeur.hash.u, season: echangeur.hash.season || "", status: echangeur.hash.status || "inprogress" }, '', 'orders');

    },
    onLoad: function (echangeur) {

        let THIS = this;

        // @Dev : nom des variables et passage des variable environement

        let env = echangeur.hash.u;

        console.log(` ENV : ${env}`);

        const app = createApp({
            components: {
                'dropdown-ellipses': b2bDropdownEllipses,
                Doughnut,
            },
            data() {
                return {
                    datas: PrepareData(echangeur.orders.rows),
                    creators: echangeur.orders.squi,
                    groups: echangeur.orders.sgrp,
                    names: echangeur.orders.names,
                    checkeds: false,
                    // Navbar
                    tabs,
                    selectedIndex: 0,
                    selectedTab: tabs[0], // 'inprogress',
                    // Fuse
                    // fuse: null,
                    // search: null,
                    // searchKey: null,
                    fuse: null,
                    searchKey: '',
                    // Tri
                    triActuel: '',
                    choixChart: 'order',
                    //
                    currentToc: echangeur.hash.season || echangeur.default.v || echangeur.default.tocK,
                    tocs: echangeur.toc.rows,
                    selectedToc: "",
                    createdby: '',
                    env: env
                }
            },

            computed: {
                totalCheck() {
                    return {
                        confirm: this.getCheckedConfirm().length,
                        duplicate: this.getCheckedConfirm().length,
                        validate: this.getCheckedValidate().length,
                        delete: this.getCheckedDelete().length,
                        stats: this.getChecked().length,
                        xls: this.getChecked().length,
                        pdf: this.getChecked().length
                    }
                },
                list() {
                    const nb = echangeur.orders.nbbystatus;
                    let inprogress = 0;
                    let confirmed = 0;
                    let validated = 0;
                    let exportded = 0;
                    let duplicate = 0;
                    for (const u of nb) {
                        if (u._id.status == 11) {
                            validated = u.count;
                        }
                        if (u._id.status == 10) {
                            inprogress = u.count;
                        }
                        if (u._id.status == 9) {
                            if (u._id.majerp) {
                                exportded = u.count;
                            } else {
                                confirmed = u.count;
                            }
                        }
                    }
                    return { inprogress, confirmed, validated, exportded, all: (inprogress + confirmed + validated + exportded) };
                }
            },
            methods: {
                switchToc() {
                    //console.log(this.currentToc)
                },
                getName(k) {
                    return (this.names[k]) ? this.names[k].displayname : k;
                },
                may(key) {
                    return may(key);
                },

                getChecked() {
                    return this.datas.filter(u => (u.checked));
                },

                getCheckedConfirm() {
                    return this.datas.filter(u => (u.checked && u.actions.confirm));
                },

                getCheckedValidate() {
                    return this.datas.filter(u => (u.checked && u.actions.validate));
                },

                getCheckedDelete() {
                    return this.datas.filter(u => (u.checked && u.actions.del));
                },
                getCheckedDuplicate() {
                    return this.datas.filter(u => (u.checked && u.actions.confirm) || (u.checked && u.actions.validate));
                    //
                },

                async showTab(index) {

                    this.selectedIndex = index;
                    this.selectedTab = tabs[index];

                    const orders = await THIS.rest('b2b.orders.list', { env: env, season: "", status: this.selectedTab.k, majerp: this.selectedTab.majerp }, '', 'orders');
                    this.datas = PrepareData(orders.rows);

                    this.tri(this.datas, this.triActuel);
                    this.lanceRecherche();
                    this.checkeds = false;

                },

                confirmOrder() {
                    let lists = this.getCheckedConfirm().map(u => u._id);
                    if (lists.length) THIS.hashLance("orderVerifie", { u: env,env:env, _ids: lists.join(','), ecran: "confirm" });
                },

                validateOrder() {
                    let lists = this.getCheckedValidate().map(u => u._id);
                    if (lists.length) THIS.hashLance("orderVerifie", { u: env,env:env, _ids: lists.join(','), ecran: "validate" });
                },

                deleteOrder() {
                    let lists = this.getCheckedDelete().map(u => u._id);
                    if (lists.length) THIS.hashChaine("orderVerifie", { u:env,env:env, _ids: lists.join(','), ecran: "delete" });

                },
                // duplicateOrder() {
                //     let lists = this.getCheckedDuplicate().map(u => u._id);
                //     if (lists.length==1) THIS.hashChaine("orderDuplicate", { _ids: lists[0], ecran: "duplicate" });
                // },

                selectCheck() {
                    if (this.checkeds == true) this.checkeds = false
                    //console.log(this.list[this.selectedTab.k])

                    // let a = this.datas.filter(u => (u.checked))
                    // console.log(a)

                    // if (this.form.clients.length != this.blocs.length) {
                    //     this.checkeds = false
                    // } else {
                    //     this.checkeds = true
                    // }
                },

                selectAll() {
                    const selectedTabK = this.selectedTab.k

                    const filter = function (u) { return selectedTabK == 'all' || (selectedTabK == u.badge.k) }

                    if (this.checkeds == false) this.datas.filter(filter).map(u => { if (u.inSearch) u.checked = true })
                    //if (this.checkeds == true) this.datas.filter(filter).map(u => { u.checked = false })
                    if (this.checkeds == true) this.datas.map(u => { u.checked = false })
                },

                colorBadge(item) {
                    return item.badge.color;
                },
                duplicateOrder(_idOrder) {
                    let lists = this.getCheckedDuplicate().map(u => u._id);
                    if (lists.length != 1) return false;

                    //console.log(lists)

                    Store.get("duplicateOrder")(
                        function (_id) {
                            THIS.hashLance("orderValidate", { _id });
                        },
                        { _id: lists[0] }
                    );
                },
                createOrder() {
                    Store.get("creatOrder")(
                        function (_id) {
                            THIS.hashLance("orderValidate", { _id });
                        }
                    );
                },

                toPrix(value, devise) {
                    return toPrix(value, devise);
                },

                async statsOrder() {

                    const _ids = this.datas.filter(u => u.checked).map(u => u._id);

                    const result = await THIS.rest("b2b.orders.stats", { _ids });

                    const modaleApp = createApp({

                        data: function () {
                            return {
                                tableaux: [
                                    construitTableau(result.stats.collectiontype, { caption: "Collection type" }),
                                    construitTableau(result.stats.deliverytheme, { caption: "Delivery Theme" }),
                                    construitTableau(result.stats.department, { caption: "Product Department" }),
                                    construitTableau(result.stats.familyV, { caption: "Family" }),
                                    construitTableau(result.stats.couG, { caption: "Generic Color" }),
                                    construitTableau(result.stats.heel, { caption: "Heels" }),
                                    construitTableau(result.stats.desc, { caption: "Short Desc" })
                                ],
                                triActuel: '',
                                triSens: -1,
                                choixChart: 'qt',
                            }
                        },
                        components: { Doughnut },

                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            toPrix(value, devise) {
                                return toPrix(value, devise);
                            },
                            pourcent(qt, totalQt) {
                                if (!totalQt) return ' '
                                return ((qt / totalQt) * 100).toFixed(0) + " %"
                            },

                            toChart(array) {
                                // https://vue-chartjs.org/examples/#vue-3-charts
                                let data = {
                                    labels: [],
                                    datasets: [{
                                        data: [],
                                        backgroundColor: colors
                                    }]
                                }

                                for (const item of array) {
                                    if (item[this.choixChart] > 0) {
                                        // @ts-ignore
                                        data.labels.push(item.v || item.key)
                                        // @ts-ignore
                                        data.datasets[0].data.push(item[this.choixChart])
                                    }
                                }
                                return data
                            },

                            tri(tableau, name) {
                                tableau.sens = (this.triActuel == name) ? -tableau.sens : 1
                                if (name == 'qt') tableau.rows.sort((a, b) => (b.qt - a.qt) * tableau.sens);
                                if (name == 'ht') tableau.rows.sort((a, b) => (b.ht - a.ht) * tableau.sens);
                                if (name == 'nb') tableau.rows.sort((a, b) => (b.nb - a.nb) * tableau.sens);
                                this.triActuel = name
                                this.choixChart = name
                            }

                        },

                        mounted() {
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    // @ts-ignore
                    modaleApp.mount(ModalHelper.html(orderChart).container);
                },

                massImport() {
                    window.location.href = '#orderMassImport&u=' +env;  
                },

                toDate(value) {
                    return toDate(value);
                },

                async xls(version) {
                    const _id = this.getChecked().map(u => u._id);
                    const t = await THIS.rest("b2b.order.xls", { _id, version }, {});
                    if (t.url) window.open(t.url);
                },

                async pdf() {
                    const _id = this.getChecked().map(u => u._id);
                    const t = await THIS.rest("b2b.order.pdf", { _id, version: '' }, {});
                    if (t.url) window.open(t.url);
                },

                editOrder(item) {
                    // console.log(item)
                    THIS.hashLance("orderValidate", { _id: item._id })
                },

                filterbycreator() {
                    this.createdby;
                    this.lanceRecherche();
                },

                filterbyselectedToc() {
                    //this.selectedToc
                    this.lanceRecherche();
                },

                lanceRecherche() {
                    const val = this.searchKey;

                    this.checkeds = false;
                    this.datas.map(u => { u.checked = false });

                    if (val) {
                        this.search = this.fuse.search(val);
                        let indexSearch = this.search.map(e => e.item._id);
                        this.datas.forEach(u => {
                            let filtrequi = true;
                            if (this.createdby) {
                                const g = this.createdby.match(/^group:(.+)$/)
                                if (g) {
                                    filtrequi = g[1] && this.groups[g[1]] && this.groups[g[1]].rows && (this.groups[g[1]].rows.includes(u.qui));
                                } else {
                                    filtrequi = (u.qui == this.createdby);
                                }
                            }

                            let filtreSeason = true
                            if (this.selectedToc) filtreSeason = (u.season === this.selectedToc)

                            u.inSearch = (indexSearch.includes(u._id) && filtrequi && filtreSeason);
                        });
                    } else {
                        this.datas.forEach(u => {
                            let filtrequi = true;
                            if (this.createdby) {
                                const g = this.createdby.match(/^group:(.+)$/)
                                if (g) {
                                    filtrequi = g[1] && this.groups[g[1]] && this.groups[g[1]].rows && (this.groups[g[1]].rows.includes(u.qui));
                                } else {
                                    filtrequi = (u.qui == this.createdby);
                                }
                            }

                            let filtreSeason = true
                            if (this.selectedToc) filtreSeason = (u.season === this.selectedToc)

                            u.inSearch = filtrequi && filtreSeason;//true;
                        });
                    }
                },

                tri(tableau, name) {
                    const sens = (this.triActuel == name) ? - this.triSens : 1

                    if (name == 'order') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'season') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'department') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'ordertype') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'customer') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'code') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'po') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'dateCre') tableau.sort((a, b) => a[name].localeCompare(b[name]) * sens);
                    if (name == 'nbproducts') tableau.sort((a, b) => (b[name] - a[name]) * sens);
                    if (name == 'total') tableau.sort((a, b) => (b[name] - a[name]) * sens);
                    if (name == 'badge') tableau.sort((a, b) => a.badge.v.localeCompare(b.badge.v) * sens);

                    this.triActuel = name
                    this.triSens = sens;
                    this.fuse = new Fuse(this.datas, fuseOptions);
                },

                t(value) {
                    return traduit(value, 'global');
                }
            },

            watch: {
                "searchKey"(val) {
                    this.lanceRecherche();
                },
                "currentToc"() {
                    this.switchToc()
                },
                "item.checked"() {
                    /*                     if (this.form.clients.length != this.blocs.length) {
                                            this.checkeds = false
                                        } else {
                                            this.checkeds = true
                                        } */
                }
            },

            mounted() {
                this.fuse = new Fuse(this.datas, fuseOptions);
            }

        });

        this.vm = app.mount(THIS.c$('._vueChargement')[0]);
    },
    reprise: async function (ecran) {
        await this.vm.showTab(this.vm.$data.selectedIndex);
        //console.log("reprise", ecran)

        this.toggle(true);
        ecran.restaure();
    }
});

export default {
    orderList: { js: js, html: html }
};

function construitTableau(array, options) {

    const total = { qt: 0, ht: 0, nb: 0 }

    for (const item of array) {
        total.qt += item.qt
        total.ht += item.ht
        total.nb += item.nb
    }

    const retour = Object.assign({}, options)
    retour.rows = array
    retour.total = total
    retour.tri = ""
    retour.sens = ""
    return retour
}

const colors = [
    "#2196F3",
    "#E3F2FD",
    "#BBDEFB",
    "#90CAF9",
    "#64B5F6",
    "#42A5F5",
    "#1E88E5",
    "#1976D2",
    "#1565C0",
    "#0D47A1",
    "#3F51B5",
    "#E8EAF6",
    "#C5CAE9",
    "#9FA8DA",
    "#7986CB",
    "#5C6BC0",
    "#3949AB",
    "#303F9F",
    "#283593",
    "#1A237E"
]
